<template>
  <div>
    <van-sticky>
      <van-nav-bar
        :title="$route.query.title+'('+this.countStu+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />

      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in students" :key="item.id">
          <van-cell :border="false" :label="item.sgender+' '+item.snum" :title="item.sname" value="<--"/>
          <template slot="right">
            <van-button square type="danger" @click="delStuById(item.sid)" text="刪除"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar, SwipeCell, Cell, Button, List, PullRefresh, Toast, Dialog, Search, Pagination, Sticky
} from 'vant';
import {GetPhyTestStuListLikeKeyByPage, DelStuInPhyTestSelect, GetPhyTestStuListCountByKey} from "@/network/stuSelect";

Vue.use(NavBar);
Vue.use(SwipeCell);
Vue.use(Cell);
Vue.use(Button);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Search);
Vue.use(Pagination);
Vue.use(Sticky);
export default {
  name: "PhyTestStudents",
  data() {
    return {

      students: [],

      //搜索框
      searchValue: '',

      //刷新列表
      refreshing: false,
      loading: false,
      finished: true,

      //统计多少学生
      countStu: 0,

      //分页
      currentPage: 0
    }
  },
  activated() {
    GetPhyTestStuListCountByKey(this.$route.query.id, "").then(res => {
      this.countStu = res;
    });
    this.GetPhyTestStuListLikeKeyByPage("");
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  methods: {
    onSearch(val) {
      this.GetPhyTestStuListLikeKeyByPage(val);
      GetPhyTestStuListCountByKey(this.$route.query.id, val).then(res => {
        this.countStu = res;
      });
    },
    onCancel() {
      this.GetPhyTestStuListLikeKeyByPage("");
      GetPhyTestStuListCountByKey(this.$route.query.id, "").then(res => {
        this.countStu = res;
      });
    },
    onPageChange() {
      this.GetPhyTestStuListLikeKeyByPage(this.searchValue, this.currentPage);
    },
    GetPhyTestStuListLikeKeyByPage(name, page = 1) {
      GetPhyTestStuListLikeKeyByPage(this.$route.query.id, name, page).then(res => {
        this.students = [];
        // this.countStu = res.length;
        this.students.push(...res);
      })
    },
    onClickLeft() {
      this.$router.replace("TestBookingManageList");
    },
    delStuById(sId) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelStuInPhyTestSelect(sId, this.$route.query.years, this.$route.query.months, this.$route.query.days).then(res => {
            if (res) {
              this.students = this.students.filter(item => item.sId != sId);
              // this.countStu = this.students.length;
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });

    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.students = [];
      // 重新加载数据
      this.GetPhyTestStuListLikeKeyByPage("");
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
    },
  }
}
</script>

<style scoped>

</style>
